import { Button, Card, Col, DatePicker, Row, Space } from "antd";
import {
  deleteSchedule,
  removeScheduleDate,
  updateValuesSchdedule,
} from "../Slices/InterpreteSlice";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { daysJsFormat } from "../../../utils/constants";
import dayjs, {
  dateCustomFormat,
  generalFormatAntd,
} from "../../../utils/dayjs";
import { AiFillDelete } from "react-icons/ai";
import useDeviceDetect from "../../../engine/hooks/useDeviceDetect";
import frFR from "antd/es/date-picker/locale/fr_FR";
import itIT from "antd/es/date-picker/locale/it_IT";
import { t } from "i18next";
import i18next from "i18next";

const range = (start, end) => {
  const result = [];
  for (let i = start; i < end; i++) {
    result.push(i);
  }
  return result;
};
export const ScheduleNotAvailable = ({ schedule }) => {
  const dispatch = useDispatch();

  const { isMobile } = useDeviceDetect(1024);

  const [canUpdate, setCanUpdate] = useState(false);

  useEffect(() => {
    if (schedule.id !== undefined) {
      setCanUpdate(true);
    }
  }, []);

  const disabledDate = current => {
    // Can not select days before today and today
    return current < dayjs().endOf("day");
  };
  const disabledRangeTime = (_, type) => {
    if (type === "start") {
      return {
        disabledHours: () => range(0, 60).splice(4, 20),
        disabledMinutes: () => range(30, 60),
        disabledSeconds: () => [55, 56],
      };
    }
    return {
      disabledHours: () => range(0, 60).splice(20, 4),
      disabledMinutes: () => range(0, 31),
      disabledSeconds: () => [55, 56],
    };
  };

  return (
    <Card style={{ marginBottom: 15 }} key={schedule._id || schedule.id}>
      <Row gutter={[15, 15]}>
        {!canUpdate ? (
          <Col style={{ flex: 1 }}>
            <Space style={{ padding: 9 }}>
              <span style={{ color: "#7E7E7E" }}>du</span>
              <strong>
                {dayjs(schedule.dateFrom).customFormat(daysJsFormat.full)}{" "}
              </strong>
              <span style={{ color: "#7E7E7E" }}>au</span>
              <strong>
                {dayjs(schedule.dateTo).customFormat(daysJsFormat.full)}
              </strong>
            </Space>
          </Col>
        ) : (
          <Col style={{ flex: 1 }}>
            <DatePicker.RangePicker
              locale={i18next.language === "fr" ? frFR : itIT}
              disabledDate={disabledDate}
              placeholder={[t("common.du"), t("common.au")]}
              showTime={{
                format: "HH:mm", // Ici, on spécifie le format sans les secondes
              }}
              format={dateCustomFormat}
              defaultValue={[dayjs(schedule.dateFrom), dayjs(schedule.dateTo)]}
              onChange={(u, s) => {
                dispatch(
                  updateValuesSchdedule({
                    ...schedule,
                    dateFrom: u[0].format(),
                    dateTo: u[1].format(),
                  }),
                );
              }}
              style={{ width: "100%" }}
            />
          </Col>
        )}

        <Button
          type={"text"}
          danger={true}
          onClick={() => setCanUpdate(!canUpdate)}
        >
          {canUpdate
            ? t("interpreteSchedule.confirm")
            : t("interpreteSchedule.modify")}
        </Button>
        <Button
          type={"text"}
          danger={true}
          onClick={() => {
            dispatch(
              removeScheduleDate({
                id: schedule.id,
                _id: schedule._id,
              }),
            );

            if (schedule._id !== undefined) {
              dispatch(deleteSchedule(schedule._id));
            }
          }}
        >
          {isMobile ? <AiFillDelete /> : t("interpreteSchedule.delete")}
        </Button>
      </Row>
    </Card>
  );
};
